import { withNamespaces } from 'react-i18next';

import getStateVisuals from './stateVisuals';
import NodeHandles from './NodeHandles';

const stateDescriptions = {
    pending: 'Waiting for branches',
    processing: 'Analysis in progress',
    completed: 'Analysis complete',
    warning: 'Analysis complete',
    failed: 'Analysis complete',
};

const AnalysisNode = ({
    data,
    t,
}) => {
    const visuals = getStateVisuals(data.state);

    return (
        <>
            <NodeHandles />

            <div className="text-center" style={{ width: 130 }}>
                <div className="avatar-xs mx-auto mb-1">
                    <span className={`avatar-title rounded-circle bg-soft-${visuals.color} text-${visuals.color} font-size-16`}>
                        <i className="ri-focus-3-line" />
                    </span>
                </div>

                <div className="font-size-12 fw-medium">{t(data.label)}</div>
                <div className={`font-size-11 text-${visuals.color}`}>
                    {t(stateDescriptions[data.state] || stateDescriptions.pending)}
                </div>
                <div className="font-size-11 text-muted">
                    {`${data.completedBranches} / ${data.totalBranches} ${t('categories')}`}
                </div>
            </div>
        </>
    );
};

export default withNamespaces()(AnalysisNode);
